import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { CurrentSeasonStats } from '../../models/current-season-stats';
import { GlobalStats } from '../../models/global-stats';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NbTooltipModule } from '@nebular/theme';
import { ContactComponent } from "../../shared/components/contact/contact.component";
import { HomeService } from '../../services/home.service';
import {environment} from "../../../environments/environment";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    TranslateModule,CommonModule, SlickCarouselModule, NbTooltipModule, ContactComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  previousValue = 4;
  constructor(private homeService: HomeService) {}

  homeInfo = signal<{
    slideConfig?: {
      slidesToShow: number,
      slidesToScroll: number
    },
    slides?: { id: number, caption: string, image: string }[],
    resume?: string,
    message1?: string,
    message2?: string,
    currentSeasonStats?: CurrentSeasonStats,
    globalStats?: GlobalStats
  }>({});

  ngOnInit(): void {
    this.homeService.infos().subscribe((infos: any) => {
      this.homeInfo.set(infos);
    });
  }

  getVideoLink() {
    return `${environment.apiUrl}/videos/annonce_ligue_ecl_s3.mp4`;
  }
}
